/**
 * Scroll utilities for form error handling and navigation
 */

/**
 * Scrolls to the first input with a validation error on the page.
 * Centers the input vertically on the screen.
 *
 * @param {Object} options - Configuration options
 * @param {string} options.inputErrorSelector - CSS selector for inputs with errors (default: '.picked, .is-invalid')
 * @param {string} options.behavior - Scroll behavior: 'smooth' or 'auto' (default: 'smooth')
 */
export const scrollToFirstError = (options = {}) => {
  const { behavior = 'smooth' } = options;

  const errorMessages = Array.from(document.querySelectorAll('.validation-error')).filter(el => {
    const style = window.getComputedStyle(el);
    return style.display !== 'none' &&
           style.visibility !== 'hidden' &&
           el.offsetParent !== null;
  });

  if (errorMessages.length === 0) return;

  errorMessages.sort((a, b) => {
    return (a.getBoundingClientRect().top + window.scrollY) -
           (b.getBoundingClientRect().top + window.scrollY);
  });

  const scrollTarget = errorMessages[0].closest('.d-flex.flex-column') || errorMessages[0];
  scrollTarget.scrollIntoView({
    behavior,
    block: 'center',
    inline: 'nearest'
  });
};

/**
 * Scrolls to page top (for confirmation pages).
 *
 * @param {Object} options - Configuration options
 * @param {number} options.offset - Pixels from absolute top (default: 0)
 * @param {string} options.behavior - Scroll behavior (default: 'smooth')
 */
export const scrollToPageTop = (options = {}) => {
  const { offset = 0, behavior = 'smooth' } = options;
  window.scrollTo({ top: offset, behavior });
};
